import { SxProps } from '@mui/material'

import theme from '../../styles/themes/default.theme'

const styles = {
  // -- Cart container (original) --
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius / 4,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('md')]: {
      borderRadius: 0,
      border: 'none',
      boxShadow: 'none',
      paddingY: 0
    }
  } as SxProps,

  // -- Fulfillment compact container --
  fulfillmentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '20px',
    // borderRadius: 8,
    border: '1px solid #E5E7EB',
    backgroundColor: '#FFFFFF'
  } as SxProps,

  fulfillmentTitleText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1F2937'
  } as SxProps,

  fulfillmentDivider: {
    backgroundColor: '#E5E7EB',
    height: '1px'
  } as SxProps,

  // -- Item widget container (used by Overview; ItemWidget has its own styles) --
  itemWidgetContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  } as SxProps,

  // -- Original styles (cart) --
  divider: {
    marginBottom: theme.spacing(1)
  } as SxProps,

  title: {
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'left'
  } as SxProps,

  recipientSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottom: '1px solid',
    borderColor: theme.palette.divider
  } as SxProps,

  recipientTable: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      padding: theme.spacing(1, 2),
      verticalAlign: 'top'
    }
  } as SxProps,

  tableLabel: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
    width: 'auto',
    whiteSpace: 'nowrap',
    paddingRight: theme.spacing(2)
  } as SxProps,

  sectionTitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(1)
  } as SxProps,

  itemsLabelText: {
    textAlign: 'left',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: '14px'
    }
  } as SxProps,

  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    paddingY: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  } as SxProps,

  emptyStateIcon: {
    fontSize: 40,
    color: theme.palette.grey[300]
  } as SxProps,

  emptyStateText: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey[500]
  } as SxProps,

  emptyStateHint: {
    fontSize: '12px',
    color: theme.palette.grey[400],
    textAlign: 'center'
  } as SxProps,

  packageStatsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  } as SxProps,

  packageStatRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  } as SxProps,

  packageStatLabel: {
    fontSize: '13px',
    color: theme.palette.grey[500]
  } as SxProps,

  packageStatValue: {
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.grey[800]
  } as SxProps
}

export default styles
